<template>
    <div id="campaign">
        <a href="#">
            <img :src="data.url"/>
        </a>
    </div>
</template>

<script>
    export default {
        name: 'Campaign',
        props: ['data'],
        data() {
            return {

            }
        }
    }
</script>

<style lang="scss">
    #campaign {
        img {
            width: 100%;
        }
    }
</style>